import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/projectStatusCreation/styles.scss';export default {
  "projectStatusesList": "_projectStatusesList_c4hg2_1",
  "heading": "_heading_c4hg2_5",
  "title": "_title_c4hg2_9",
  "subTitle": "_subTitle_c4hg2_15",
  "statuses": "_statuses_c4hg2_20"
};